import moment from 'moment';

export function pegarDataUtc(data) {
  return moment(data).utc(true);
}

export function pegarDataMoment(data) {
  return moment(data);
}

export function formatarData(data) {
  return moment(data).format('DD/MM/YYYY');
}
